import React from 'react'

import { HeaderRow } from './styled'
import { InlineMenuHeader } from '../InlineMenu'

const AdminHeader = () => {
  return (
    <HeaderRow>
      <InlineMenuHeader />
    </HeaderRow>
  )
}

export default AdminHeader
